import { useMemo } from 'react';

const ALL_SPACE = 12;
const TWICE_SPACE = 24;

type size = boolean | 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

interface SizesByMediaQueries {
  xs: size;
  sm: size;
  md: size;
  lg: size;
  xl: size;
}

interface SizesByMediaQueriesResult {
  periodSizes: SizesByMediaQueries;
  rangeSizes: SizesByMediaQueries;
  userFilterSizes: SizesByMediaQueries;
  stateFilterSizes: SizesByMediaQueries;
  buttonSizes: SizesByMediaQueries;
}

export function useSizesByMediaQueries(
  withFilterByState: boolean,
  withFilterByUser: boolean,
  withDatePicker: boolean,
  withButton: boolean,
): SizesByMediaQueriesResult {
  return useMemo(() => {
    const periodSizesXL = 2;
    const rangeSizesXL = withDatePicker ? 4 : 0;
    const userFilterSizesXL = withFilterByUser ? 2 : 0;
    const stateFilterSizesXL = withFilterByState ? 2 : 0;

    const periodSizesLG = 3;
    const rangeSizesLG = withDatePicker ? 6 : 0;
    const userFilterSizesLG = withFilterByUser ? 3 : 0;
    const stateFilterSizesLG = withFilterByState ? 3 : 0;

    const periodSizesMD = withDatePicker ? 5 : 6;
    const rangeSizesMD = withDatePicker ? 7 : 0;
    const userFilterSizesMD = withFilterByUser ? 6 : 0;
    const stateFilterSizesMD = withFilterByState ? 6 : 0;

    const periodSizes = {
      xl: periodSizesXL,
      lg: periodSizesLG,
      md: periodSizesMD,
      sm: 12,
      xs: 12,
    };
    const rangeSizes = {
      xl: rangeSizesXL,
      lg: rangeSizesLG,
      md: rangeSizesMD,
      sm: 12,
      xs: 12,
    };
    const userFilterSizes = {
      xl: userFilterSizesXL,
      lg: userFilterSizesLG,
      md: userFilterSizesMD,
      sm: 12,
      xs: 12,
    };
    const stateFilterSizes = {
      xl: stateFilterSizesXL,
      lg: stateFilterSizesLG,
      md: stateFilterSizesMD,
      sm: 12,
      xs: 12,
    };

    const spaceBeforeBtnXL =
      periodSizesXL + rangeSizesXL + userFilterSizesXL + stateFilterSizesXL;
    const spaceBeforeBtnLG =
      periodSizesLG + rangeSizesLG + userFilterSizesLG + stateFilterSizesLG;
    const spaceBeforeBtnMD =
      periodSizesMD + rangeSizesMD + userFilterSizesMD + stateFilterSizesMD;

    const buttonSizes = {
      xl: ALL_SPACE - spaceBeforeBtnXL,
      lg:
        (spaceBeforeBtnLG > ALL_SPACE
          ? TWICE_SPACE - spaceBeforeBtnLG
          : spaceBeforeBtnLG === ALL_SPACE
          ? ALL_SPACE
          : ALL_SPACE - spaceBeforeBtnLG) || ALL_SPACE,
      md:
        (spaceBeforeBtnMD > ALL_SPACE
          ? TWICE_SPACE - spaceBeforeBtnMD
          : spaceBeforeBtnMD === ALL_SPACE
          ? ALL_SPACE
          : ALL_SPACE - spaceBeforeBtnMD) || ALL_SPACE,
      sm: 12,
      xs: 12,
    };

    return {
      periodSizes,
      rangeSizes,
      userFilterSizes,
      stateFilterSizes,
      buttonSizes,
    } as SizesByMediaQueriesResult;
  }, [withFilterByState, withFilterByUser, withDatePicker, withButton]);
}
